import React from "react";


const CircularProgress = ({className}) => <div className={`loader ${className}`}>

</div>;
export default CircularProgress;
